// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bby_a bih_i bih_j","ColorVariants__color":"bby_b bih_rp","ColorVariants__more":"bby_c bih_vv"};